const API_URL = "https://haymiutyun-web-api-fjefgndahrdheghg.francecentral-01.azurewebsites.net"
//const API_URL = "https://localhost:44325"

export default API_URL